(() => {
  'use strict';
  function bootPreviews() {
    document.querySelectorAll('[data-sh-preview-gallery]').forEach(gallery => {
      if (gallery.dataset.shPreviewReady) return;
      gallery.dataset.shPreviewReady = 'true';
      const dialog = gallery.querySelector('dialog');
      const image = dialog?.querySelector('[data-sh-preview-image]');
      const title = dialog?.querySelector('[data-sh-preview-title]');
      const original = dialog?.querySelector('[data-sh-preview-original]');
      if (!dialog || !image || !title || !original || typeof dialog.showModal !== 'function') return;
      let trigger;
      let previousOverflow = '';
      gallery.querySelectorAll('[data-sh-preview-open]').forEach(link => {
        link.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          trigger = link;
          image.src = link.href;
          image.alt = link.querySelector('img')?.alt || link.dataset.previewTitle || '';
          title.textContent = link.dataset.previewTitle || '';
          original.href = link.href;
          previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          dialog.showModal();
        });
      });
      dialog.querySelector('[data-sh-preview-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow;
        trigger?.focus({preventScroll: true});
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootPreviews, {once: true});
  else bootPreviews();
  document.addEventListener('shopify:section:load', bootPreviews);
})();
